export default __webpack_public_path__ + "static/media/outlook.95a10048.png";